// Browser-specific: hardware sample rate (usually 48kHz) -> 16kHz mono.
// Core's contract requires pcm16k always be true 16kHz — never assume the
// browser gave us that just because we asked getUserMedia for it.
export function resampleTo16kMono(
  float32: Float32Array,
  inputSampleRate: number,
  targetSampleRate = 16000,
): Float32Array {
  if (inputSampleRate === targetSampleRate) return float32;

  const ratio = inputSampleRate / targetSampleRate;
  const outputLength = Math.round(float32.length / ratio);
  const output = new Float32Array(outputLength);

  for (let i = 0; i < outputLength; i++) {
    const srcPos = i * ratio;
    const srcIndex = Math.floor(srcPos);
    const frac = srcPos - srcIndex;
    const s0 = float32[srcIndex] ?? 0;
    const s1 = float32[srcIndex + 1] ?? s0;
    output[i] = s0 + (s1 - s0) * frac;
  }

  return output;
}
